import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { COLOR_WHITE_20 } from "shared/theme/colors";

export const StyledSeparator = styled(Box)`
  border: 0.2px solid ${COLOR_WHITE_20};
  margin: 0 1rem;
  box-sizing: border-box;
`;
